import { render, staticRenderFns } from "./ConfirmManuscript.vue?vue&type=template&id=08a2f218&scoped=true"
import script from "./ConfirmManuscript.vue?vue&type=script&lang=js"
export * from "./ConfirmManuscript.vue?vue&type=script&lang=js"
import style0 from "./ConfirmManuscript.vue?vue&type=style&index=0&id=08a2f218&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a2f218",
  null
  
)

export default component.exports